import {useEffect} from 'react'
import {useDispatch} from 'react-redux'
import {useQuery} from '@tanstack/react-query'
import {BlockPagesResponse} from 'interfaces'
import {SettingsService} from 'services/api'
import Toast from 'components/Basic/Toast'
import {settingsActions} from '../settingsSlice'

export const BLOCK_PAGES_QUERY_KEY = 'getBlockPages'
export const useBlockPagesQuery = () => {
  const dispatch = useDispatch()
  const {data, error, isFetching, isLoading, isSuccess, refetch} = useQuery({
    queryKey: [BLOCK_PAGES_QUERY_KEY],
    queryFn: () => SettingsService.getBlockPages(),
  })
  const blockPagesData = data?.data as BlockPagesResponse

  useEffect(() => {
    // On settings general page, we prefetch the block pages data
    // Check if the data is available and dispatch the action
    if (isSuccess && blockPagesData) {
      dispatch(settingsActions.getBlockPagesSuccess(blockPagesData))
    }
  }, [])

  useEffect(() => {
    if (isSuccess && !isFetching) {
      dispatch(settingsActions.getBlockPagesSuccess(blockPagesData))
    }
  }, [isSuccess, isFetching])

  useEffect(() => {
    if (error) {
      Toast({message: error, type: 'error'})
    }
  }, [error])

  return {
    isFetching,
    isLoading,
    isSuccess,
    refetch,
  }
}
